import React from 'react'
import { BarTeam } from './BarTeam'
import { FanResult } from '../../../../Api'
import { calcPercent, getTeamColor, getFullTeamName } from '../../../../Utils'
import { BarCon, BarHead } from './styles'

type BarProps = {
  seasonSegment: string
  fanBracketResults: FanResult[]
  totalCount: number
}

export const MultiBar: React.FC<React.PropsWithChildren<BarProps>> = ({ seasonSegment, fanBracketResults, totalCount }) => {
  return (
    <>
      <BarHead>
        {seasonSegment === 'post' && <p>Which team did fans pick to win the championship?</p>}
        {seasonSegment !== 'post' && <p>Which team did fans pick to win?</p>}
      </BarHead>
      <BarCon>
        {fanBracketResults.map((result) => (
          <BarTeam
            key={result.teamId}
            percent={calcPercent(result.count, totalCount)}
            teamColor={getTeamColor(result.teamId)}
            teamName={getFullTeamName(result.teamId)}
          />
        ))}
      </BarCon>
    </>
  )
}
